import './index.scss';

import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../button';

const RepeatCustomization = props => {
  const location = useLocation();
  const {
    addnewClick,
    repeatClick,
    theme,
    name,
    description,
    extraDetails
  } = props;
  console.log(props, ' propspropsprops ');
  const {
    variant_name,
    is_from_offer,
    show_customise,
    is_has_addons
  } = extraDetails;
  const grayedOutClass =
    show_customise && !is_from_offer && is_has_addons
      ? ''
      : !is_from_offer && is_has_addons
      ? ''
      : 'grayed-out-button';
  return (
    <div className="repeat">
      <div className="repeat__title">Repeat Customisation?</div>
      <span className="repeat__item-name">{name}</span>{' '}
      <span className="repeat__item-name">
        {`${!!variant_name ? `(${variant_name})` : ''}`}
      </span>
      {location.pathname !== '/' && (
        <p className="repeat__item-description">{description}</p>
      )}
      <div className="repeat__button">
        <Button
          className={`repeat__btn ${grayedOutClass}`}
          content="Add New"
          outlined
          size="is-medium"
          onClick={() => addnewClick(extraDetails)}
          theme={theme}
        />

        <Button
          className="repeat__btn"
          content="Repeat"
          size="is-medium"
          onClick={repeatClick}
          theme={theme}
        />
      </div>
    </div>
  );
};

export default RepeatCustomization;
